<template>
  <div class="auth-wrapper auth-v2">
    <v-dialog v-model="message.status" width="fit-content">
      <v-card>
        <v-toolbar dense flat dark :color="message.color">
          <span v-if="message.color==='error'" style="color: white !important;">
          خطا
            </span>
          <span v-else style="color: white !important;">
          عملیات موفق
            </span>
        </v-toolbar>

        <v-row class="ma-1">
          <v-col cols="12">
            {{ message.text }}
          </v-col>
          <v-col cols="12" md="12" class="text-left">
            <v-btn color="error" outlined dark @click="message.status=false"> بستن</v-btn>
          </v-col>

        </v-row>
      </v-card>
    </v-dialog>
    <div class="auth-inner">
      <v-row class="auth-row ma-0">
        <v-col
          lg="7"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- 3d character -->
            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                contain
                max-width="630"
                class="auth-3d-group  ma-auto"
                :src="require(`@/assets/images/nitron.jpg`)"
              ></v-img>
            </div>
          </div>
        </v-col>

        <v-col
          lg="5"
          style="height: 100vh ; overflow: auto"
          class="d-flex align-center auth-bg pa-10 pb-0 pt-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <!-- login form -->
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" lg="12" xl="12" md="12" sm="12" style="text-align: center">
                        <!-- brand logo -->
                        <v-img
                          :src="image_base_url + logo"
                          max-height="77px"
                          max-width="150px"
                          alt="logo"
                          class="ma-auto"
                        ></v-img>
                        <!--/ brand logo -->
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-form
                    ref="loginForm"
                    v-model="loginValidation"
                    autocomplete="off"
                    @submit.prevent="login"
                  >
                    <v-text-field
                      v-model="phoneEmail"
                      dense
                      autocomplete="off"
                      outlined
                      label="شماره تلفن همراه "
                      placeholder="شماره تلفن همراه "
                      hide-details="auto"
                      :rules="[v => !!v || 'لطفا شماره تلفن همراه خود را وارد نماييد .' , v => (v && v.length >= 13) || 'لطفا شماره تلفن همراه را مانند 6789 345 0912  وارد نمایید .']"
                      class="mb-2 phoneThings"
                      v-mask="'09## ### ####'"
                    ></v-text-field>

                    <v-text-field
                      v-model="password"
                      dense
                      outlined
                      :type="isPasswordVisible ? 'text' : 'password'"
                      label="رمز عبور"
                      placeholder="رمز عبور"
                      :rules="[v => !!v || 'لطفا رمز عبور خود را وارد نمایید.', v => (v && v.length >= 8) || 'لطفا رمز عبور خود را وارد نمایید.']"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      hide-details="auto"
                      class="mb-0"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                    ></v-text-field>

                    <v-btn
                      :disabled="!loginValidation"
                      block
                      dense
                      color="primary"
                      type="submit"
                      class="mt-2"
                    >
                      ورود به حساب کاربری
                    </v-btn>
                    <router-link
                      to="forgotPassword"
                      class="ms-3 pt-3 pb-3 float-right"
                    >
                      رمز عبور  خود را فراموش کرده ام!
                    </router-link>
                  </v-form>
                </v-card-text>

                <!-- create new account  -->
                <v-card-text class="d-flex align-center justify-center flex-wrap mt-0">
                  <router-link to="register">
                    ایجاد حساب کاربری جدید
                  </router-link>
                </v-card-text>

                <!-- divider -->
                <v-card-text class="d-flex align-center mt-0">
                  <v-divider></v-divider>
                  <span class="mx-5 mt-0">راههای ارتباطی</span>
                  <v-divider></v-divider>
                </v-card-text>

                <!-- socail links -->
                <v-card-actions class="d-flex justify-center">
                  <v-tooltip bottom v-for="link in socialLink" :key="link.icon">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="ms-1 mt-0"
                        :href="link.link"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon :color="$vuetify.theme.dark ? link.colorInDark:link.color">
                          {{ link.icon }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ link.tooltip }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiEyeOutline,
  mdiEyeOffOutline, mdiTelegram, mdiInstagram, mdiPhone
} from '@mdi/js'
import axios from '@axios'
import themeConfig from '@themeConfig'
import { mask } from 'vue-the-mask'
import baseConfig from '@/../baseConfig'
import router from '@/router'

import {removeCharFromString,getCookie}
  from "@/views/generator/page-handler";

export default {
  directives: { mask },
  data() {
    return {
      logo : "",
      image_base_url : baseConfig.basUrlRaw,
      message: {
        status: false,
        text: 'success operation',
        color: 'success',
      },
      loginValidation : false,
      phoneEmail: "",
      password: "",
      isPasswordVisible: false,
      alert: false,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      socialLink: [
        {
          icon: mdiTelegram,
          color: '#4267b2',
          colorInDark: '#4267b2',
          link: 'tg://resolve?domain=mevarizi',
          tooltip: 'کانال اطلاع رسانی',
        },
        {
          icon: mdiTelegram,
          color: '#b424d4',
          colorInDark: '#ba0c9d',
          link: 'tg://resolve?domain=adham54470',
          tooltip: 'ارتباط با مدیریت',
        },
        {
          icon: mdiTelegram,
          color: '#24d42d',
          colorInDark: '#078a23',
          link: "" /*'tg://resolve?domain=Ssupportvarizi'*/,
          tooltip: 'واحد پشتیبانی',
        },
        {
          icon: mdiPhone,
          color: '#24d473',
          colorInDark: '#078a56',
          link: 'tel:09117220700',
          tooltip: 'شماره تماس: 0700 722 0911',
        },
        {
          icon: mdiPhone,
          color: '#24bad4',
          colorInDark: '#07708a',
          link: 'tel:09115230700',
          tooltip: 'شماره تماس: 0700 523 0911',
        },
      ],
    }
  },
  beforeCreate() {
    this.$store.dispatch("setting/setSetting").then(()=>{
      this.socialLink[0].link=this.getValueByKey("telegram1")
      this.socialLink[1].link=this.getValueByKey("telegram2")
      this.socialLink[2].link=this.getValueByKey("telegram3")
      this.socialLink[0].tooltip=this.getValueByKey("telegramt1")
      this.socialLink[1].tooltip=this.getValueByKey("telegramt2")
      this.socialLink[2].tooltip=this.getValueByKey("telegramt3")

      this.socialLink[3].tooltip=this.getValueByKey("phonet1")
      this.socialLink[4].tooltip=this.getValueByKey("phonet2")
      this.socialLink[3].link=this.getValueByKey("phone1")
      this.socialLink[4].link=this.getValueByKey("phone2")

      this.logo = this.getValueByKey("logo")
    })
  },
  mounted() {
      console.log(getCookie("theme"))
  },
  methods: {
    getValueByKey(keySearch){
      let setting=this.$store.state.setting.setting
      return   setting.filter(s=>{
        if (s.key===keySearch)
          return  s.value
      })[0].value
    /*  if(Array.isArray(setting)){
        return   setting.filter(s=>{
          if (s.key===keySearch)
            return  s.value
        })[0].value
      }else {
        Object.keys(setting).forEach(function(key, index) {
          if(setting[key].key===keySearch)
            setting = setting[key].value;
        })
        return setting
      }*/

    },
    login() {
      if (this.loginValidation){
        axios.post(baseConfig.baseUrl +'login', {
          phoneEmail: removeCharFromString(this.phoneEmail, ' '),
          password: this.password,
        })
          .then(response => {
            if(response.data.status==="success"){
              const {token} = response.data.data
              window.sessionStorage.setItem("login","yes")
              // console.log(response.data.data.user.currentOrganizationId);
              //  alert(response.data.data.user.currentOrganizationId)
              localStorage.setItem('firstName', response.data.data.user.firstName)
              localStorage.setItem('lastName', response.data.data.user.lastName)
              localStorage.setItem('currentOrganizationId', response.data.data.user.defaultOrganizationId)
              this.$store.dispatch("user/setUser",response.data.data)
              localStorage.setItem('currentOrganizationId', response.data.data.user.defaultOrganizationId)
              localStorage.setItem('accessToken', token)
              router.push('/')
            }else{
              this.message = {
                status: true,
                text: "شماره تلفن همراه يا رمز عبور نامعتبر است .",
                color: 'error',
              }
            }
          })
      }else {
        this.$refs.loginForm.validate()
        this.alert=true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
div.d-flex:nth-child(1){
  background-color: #28243d;
}
html{
  min-height: 100%;
  position: fixed;
  min-width: 100%;
  background-color: #28243d !important;
}

</style>
<style>
.phoneThings input{
  direction: ltr !important;
}

.v-messages__message {
  line-height: 12px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  font-size: 10px;
}
</style>
